import { render, staticRenderFns } from "./order-protection-component.vue?vue&type=template&id=488ee6b0"
import script from "./order-protection-component.vue?vue&type=script&lang=js"
export * from "./order-protection-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports